import { PathBase } from "@constellation-academy/epic-ui";

export class PersonalizedNotificationTemplateEditPath extends PathBase {
	static readonly pathKey = "edit";
}
